var exports = {
  "i": "x43aef4ae--5e99f6--wrapper",
  "f": "x43aef4ae--5e99f6--wrapper--content-offset",
};

module.exports = exports;
